import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'components/admin/Admin.css';
import './BuildingSelection.css';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import SimpleTable from 'components/shared/table/SimpleTable';
import CheckBox from 'components/shared/checkbox/CheckBox';
import { getSelectedBuildingId } from 'selectors/admin/work-orders/creation/buildings';
import {
  createWorkOrderRequest,
  goToNewBuilding,
  loadBuildingsRequest,
  selectBuilding,
} from 'actions/admin/work-orders/creation/buildings';
import {
  getBuildings,
  getCurrentWorkOrder,
} from 'selectors/admin/work-orders/work-orders';
import SearchBar from 'components/shared/navigation/SearchBar';
import { getSelectedClientId } from 'selectors/admin/work-orders/creation/clients';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
import { goToClientSelection } from 'actions/admin/work-orders/creation/creation';
import { getCurrentUser } from 'selectors/authentication';
import { PermissionsUtil } from 'services/utils/permissions-util';

class BuildingSelection extends Component {
  constructor(props) {
    super(props);

    // If user is admin, check if a client is selected, otherwise route to client selection
    if (
      (usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
        usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR)) &&
      this.props.selectedClientId === null
    ) {
      this.props.dispatch(goToClientSelection());
    }
  }

  componentDidMount() {
    if (this.props.currentWorkOrder !== null) {
      this.props.dispatch(
        selectBuilding(this.props.currentWorkOrder.building.id)
      );
    }
    this.props.dispatch(
      loadBuildingsRequest(
        this.props.selectedClientId !== null
          ? this.props.selectedClientId
          : undefined
      )
    );
  }

  handleCheckboxChange = (buildingId) => {
    this.props.dispatch(
      createWorkOrderRequest(
        buildingId,
        this.props.currentWorkOrder,
        this.props.selectedClientId !== null
          ? this.props.selectedClientId
          : undefined
      )
    );
  };

  handleAddBuilding = (event) => {
    event.preventDefault();
    this.props.dispatch(goToNewBuilding());
  };

  render() {
    return (
      <div className="building-selection">
        <RouteTitle
          titles={[
            'WORK ORDERS',
            this.props.currentWorkOrder === null
              ? 'CREATE NEW'
              : 'WO #' + this.props.currentWorkOrder.number,
          ]}
        />

        <SearchBar
          addButton={
            PermissionsUtil.canCreateBuilding(this.props.currentUser) ? (
              <input
                className={'btn button button-orange button-add-work-order'}
                type="button"
                value="Add Building"
                onClick={this.handleAddBuilding}
              />
            ) : null
          }
        >
          <span className="navbar-text">
            Which Property is the Work Order for?
          </span>
        </SearchBar>

        <div className="content-container">
          <SimpleTable
            headers={['', 'ADDRESS', 'BUILDING NAME']}
            rows={this.mapBuildings(this.props.buildings)}
            emptyMessage="No Buildings"
          />
        </div>
      </div>
    );
  }

  mapBuildings = (buildings) => {
    return buildings.map((element) => {
      return [
        <CheckBox
          id={element.id}
          checked={element.id === this.props.selectedBuildingId}
          shape={'round'}
          size={'medium'}
          onChange={this.handleCheckboxChange}
        />,
        <span className="h4">
          {element.location.street_address_1 +
            ', ' +
            element.location.city +
            ', ' +
            element.location.state +
            ' ' +
            element.location.zip}
        </span>,
        element.name !== '' && element.name !== null ? element.name : 'N/A',
      ];
    });
  };
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    buildings: getBuildings(state),
    selectedBuildingId: getSelectedBuildingId(state),
    selectedClientId: getSelectedClientId(state),
  };
})(BuildingSelection);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/BuildingSelection.js